import PatientNotificationRules from './PatientNotificationRules';

export default PatientNotificationRules;
